import { atom } from 'jotai';

// Assumes a single listener (top-bar instance)
export const openGlobalSearchRequestAtom = atom(false);
